import { QuestionType } from '../../interface/multiCapabilityTemplate';
const getQuestionOptionDefaultData = () => {
    return {
        id: ``,
        title: '',
        type: 0,
        index: 0,
        extend: {
            resource_arr: [],
            setup: {},
        },
    };
};
function getQuestionDefaultData(type: QuestionType) {
    const id = ``;
    return {
        id,
        desc: '',
        paragraph_num: 0,
        type,
        question_num: 0,
        title: '',
        list: [getQuestionOptionDefaultData()],
    };
}
function compileContent(value: string) {
    const result: any[] = [];
    // 去除首尾整行的空格回车
    value = value.replace(/(^\s*\n*|^\n*\s*|\n*\s*$|\s*\n*$)/g, '');
    // 去除两个回车之间全是空格的行,多余两个回车的地方以两个算
    value = value.replace(/\n\s*\n+/g, '\n\n');
    if (value) {
        const contentList = value.split('\n\n');
        contentList.forEach((contentItem) => {
            const list = contentItem.split('\n') || [];
            const questionTitle = list.shift() || '';
            if (questionTitle) {
                const tmpList = Array.from(new Set(list));
                result.push({
                    title: questionTitle,
                    desc: '',
                    paragraph_num: 0,
                    type: QuestionType.RADIO, // 默认单选
                    question_num: tmpList.length,
                    list: tmpList.map((item, index) => {
                        return {
                            title: item,
                            type: 0,
                            index: index,
                            extend: {
                                resource_arr: [],
                                setup: {},
                            },
                        };
                    }),
                });
            }
        });
    }
    return result;
}
export { getQuestionOptionDefaultData, getQuestionDefaultData, compileContent };
